import toastBase, {
  Toaster,
  useToaster,
  useToasterStore,
  resolveValue,
  toast as toastFn,
} from '@feedback/react-hot-toast'
import { playFeedbackSound } from '../services/feedbackSoundService'

type ToastOptions = Parameters<typeof toastBase>[1]

function detectCategory(message: unknown, options?: ToastOptions) {
  const icon = options && typeof options === 'object' ? options.icon : undefined
  if (icon === '⚠️' || icon === '⚠') return 'warning' as const
  return 'info' as const
}

const feedbackToast = Object.assign(
  (message: Parameters<typeof toastBase>[0], options?: ToastOptions) => {
    playFeedbackSound(detectCategory(message, options))
    return toastBase(message, options)
  },
  toastBase,
  {
    success: (message: Parameters<typeof toastBase.success>[0], options?: Parameters<typeof toastBase.success>[1]) => {
      playFeedbackSound('save')
      return toastBase.success(message, options)
    },
    error: (message: Parameters<typeof toastBase.error>[0], options?: Parameters<typeof toastBase.error>[1]) => {
      playFeedbackSound('error')
      return toastBase.error(message, options)
    },
  }
)

export default feedbackToast
export { Toaster, useToaster, useToasterStore, resolveValue, toastFn as toast }
